import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./news.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "./../../icon/icon.png";
import { url } from "inspector";
import { relative } from "path";

const News: React.FC = (props) => {
  const [showProgessBar, setShowProgessBar] = useState(true);
  const [news, setNews] = useState("");
  const [newsSrc, setNewsSrc] = useState("");
  const [newsTitle, setNewsTitle] = useState("");
  const [newsDate, setNewsDate] = useState("");
  let base_url = process.env.REACT_APP_BASE_URL;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    let coffee = new coffeeTools();
    // console.log(coffee.test(123));
    // console.log(urlParams.get("id"));
  }, []);

  var controller = (() => {
    async function getNews(news_id) {
      let response = await fetch(base_url + "/communication/news/single", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: news_id
        })
      });
      let data = await response.json();
      return data;
    }

    return {
      getNews: async function (news_id) {
        return await getNews(news_id);
      }
    };
  })();

  let view = (() => {
    let dom_obj = {};

    function renderNews(data) {
      console.log(data);
      setNewsSrc(base_url + data.item.full_url_image);
      setNews(data.item.text);
      setNewsTitle(data.item.name);
      setNewsDate(data.item.created_at);
    }

    return {
      renderNews: function (data) {
        renderNews(data);
      }
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        // console.log("news started");
        setupEventListeners();

        // get news
        page_controller.getNews(urlParams.get("id")).then((data) => {
          view.renderNews(data);
        });

        setShowProgessBar(false);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <IonImg
            src={lnbp_logo}
            style={{ height: "4rem" }}
          ></IonImg>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div hidden={!showProgessBar}>
          <IonProgressBar type='indeterminate'></IonProgressBar>
        </div>

        <IonImg src={newsSrc}></IonImg>
        <div style={{ position: "relative" }}>
          <div className='news_content'>
            <div>
              <h1 style={{ color: "black" }}>{newsTitle}</h1>
              <hr
                style={{
                  borderBottom: "0.2rem solid #AD172B",
                  width: "30%",
                  display: "inline-block",
                  textAlign: "left",
                  color: "black",
                  backgroundColor: "#ededed"
                }}
              />
            </div>
            <small style={{ color: "black", backgroundColor: "#ededed" }}>
              {newsDate}
            </small>
            <p
              style={{ color: "black", backgroundColor: "#ededed" }}
              dangerouslySetInnerHTML={{ __html: news }}
            ></p>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default News;
